export default {
    props: {
        validationDelay: {
            type: Number,
            default: 0,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        veeValidateInteractionMode: {
            type: String,
            default: 'aggressive',
        },
    },
    computed: {
        isRequired() {
            return this.required || this.rules.required;
        },
    },
    data() {
        return {
            validationProviderRef: this.$utils.generateRandomString(),
        };
    },
    methods: {
        resetValidationProvider() {
            const ref = this.$refs[this.validationProviderRef];

            if (ref && ref.reset) {
                return ref.reset();
            }

            return null;
        },
        setFlagsValidationProvider(flags) {
            const ref = this.$refs[this.validationProviderRef];

            if (ref && ref.setFlags) {
                return ref.setFlags(flags);
            }

            return null;
        },
        validateValidationProvider(silent = true) {
            const ref = this.$refs[this.validationProviderRef];

            if (silent) {
                if (ref && ref.validateSilent) {
                    return ref.validateSilent();
                }
            } else if (ref && ref.validate) {
                return ref.validate();
            }

            return null;
        },
        async setFlagsToAllValidationProviders(flags) {
            const promises = [];
            Object.keys(this.$refs).forEach(refKey => {
                if (this.$refs[refKey] && this.$refs[refKey].setFlagsValidationProvider) {
                    promises.push(this.$refs[refKey].setFlagsValidationProvider(flags));
                }
            });
            await Promise.all(promises);
        },
    },
};
